import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsertPlanReviewAhjSubmissionAcknowledgmentMutationVariables = Types.Exact<{
  jobId: Types.Scalars['uuid']['input'];
}>;


export type InsertPlanReviewAhjSubmissionAcknowledgmentMutation = { __typename?: 'mutation_root', insert_plan_review_ahj_submission_acknowledgments_one?: { __typename?: 'plan_review_ahj_submission_acknowledgments', id: any, job_id: any, user_id: string, acknowledged_at: any } | null };


export const InsertPlanReviewAhjSubmissionAcknowledgmentDocument = gql`
    mutation insertPlanReviewAhjSubmissionAcknowledgment($jobId: uuid!) {
  insert_plan_review_ahj_submission_acknowledgments_one(object: {job_id: $jobId}) {
    id
    job_id
    user_id
    acknowledged_at
  }
}
    `;
export type InsertPlanReviewAhjSubmissionAcknowledgmentMutationFn = Apollo.MutationFunction<InsertPlanReviewAhjSubmissionAcknowledgmentMutation, InsertPlanReviewAhjSubmissionAcknowledgmentMutationVariables>;

/**
 * __useInsertPlanReviewAhjSubmissionAcknowledgmentMutation__
 *
 * To run a mutation, you first call `useInsertPlanReviewAhjSubmissionAcknowledgmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPlanReviewAhjSubmissionAcknowledgmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPlanReviewAhjSubmissionAcknowledgmentMutation, { data, loading, error }] = useInsertPlanReviewAhjSubmissionAcknowledgmentMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useInsertPlanReviewAhjSubmissionAcknowledgmentMutation(baseOptions?: Apollo.MutationHookOptions<InsertPlanReviewAhjSubmissionAcknowledgmentMutation, InsertPlanReviewAhjSubmissionAcknowledgmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPlanReviewAhjSubmissionAcknowledgmentMutation, InsertPlanReviewAhjSubmissionAcknowledgmentMutationVariables>(InsertPlanReviewAhjSubmissionAcknowledgmentDocument, options);
      }
export type InsertPlanReviewAhjSubmissionAcknowledgmentMutationHookResult = ReturnType<typeof useInsertPlanReviewAhjSubmissionAcknowledgmentMutation>;
export type InsertPlanReviewAhjSubmissionAcknowledgmentMutationResult = Apollo.MutationResult<InsertPlanReviewAhjSubmissionAcknowledgmentMutation>;
export type InsertPlanReviewAhjSubmissionAcknowledgmentMutationOptions = Apollo.BaseMutationOptions<InsertPlanReviewAhjSubmissionAcknowledgmentMutation, InsertPlanReviewAhjSubmissionAcknowledgmentMutationVariables>;